import { CSSProperties } from 'react'
import type { ThemeOptions } from '@mui/material/styles'
import { NimbraGreyLight, NimbraGreyDark, NimbraBlueDark } from './palettes'

const NimbraGrey = NimbraGreyDark
const NimbraBlue = NimbraBlueDark

const hStyles = [36, 25, 20, 18, 16, 14].reduce<{ [key: string]: CSSProperties }>(
    (acc, item, ind) => ({
        ...acc,
        [`h${ind + 1}`]: {
            fontFamily: "'Nunito Sans', sans-serif",
            fontWeight: 'bold',
            fontSize: `${item}px`,
            lineHeight: 1.6,
        },
    }),
    {}
)

export const defaultCommon: ThemeOptions = {
    shape: {
        borderRadius: 10,
    },
    palette: {
        primary: {
            main: NimbraBlue[500],
            light: NimbraBlue[300],
            dark: NimbraBlue[900],
        },
        secondary: {
            main: NimbraBlue[400],
            light: NimbraBlue[200],
            dark: NimbraBlue[800],
        },
        error: {
            main: '#D4626F',
            dark: '#C0767E',
            light: '#E84E5F',
        },
        success: {
            main: '#79D0B7',
            dark: '#8BBEAF',
            light: '#67E2BF',
        },
        warning: {
            main: '#E8CD5C',
            dark: '#D5C16F',
            light: '#FAD84A',
        },
        contrastThreshold: 3,
        grey: NimbraGrey,
    },
    typography: {
        ...hStyles,
        fontFamily: "'Roboto', sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState, theme }) => ({
                    borderRadius: '9999px',
                    textTransform: 'none',
                    ...(theme.palette.mode === 'dark' &&
                        ownerState.variant === 'outlined' &&
                        (ownerState.color === 'primary' || ownerState.color === 'secondary') && { color: '#ffffff' }),
                }),
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                    textTransform: 'none',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: ({ theme }) => (theme.palette.mode === 'dark' ? { backgroundImage: 'none' } : {}),
                rounded: {
                    borderRadius: '10px',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: NimbraGrey[700],
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                docked: {
                    width: 240,
                },
                anchorLeft: {
                    width: 240,
                    zIndex: 'unset' as const,
                },
                anchorRight: {
                    width: 240,
                    zIndex: 'unset' as const,
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: `1px solid ${NimbraGreyLight[800]}`,
                },
            },
        },
    },
}
